export default __webpack_public_path__ + "14948545ee33b97d1689fae45d7fc4ad.jpg";